export default "__VITE_ASSET__DwH4$vQ1__"